class FirebaseService {
  constructor() {
    this.db = null;
    this.storage = null;
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;

    // Verifica che Firebase sia caricato
    if (typeof firebase === 'undefined') {
      console.error('Firebase non è stato caricato. Assicurati di includere gli script Firebase nell\'HTML.');
      return;
    }

    // Configurazione Firebase
    const firebaseConfig = {
      apiKey: "AIzaSyDbVOSLc8eoQTi7s3Qqoon3ZubpEnqgkr4",
      authDomain: "home-craft-3ac21.firebaseapp.com",
      projectId: "home-craft-3ac21",
      storageBucket: "home-craft-3ac21.firebasestorage.app",
      messagingSenderId: "785824870368",
      appId: "1:785824870368:web:da39ae54a44998a80cc585"
    };


    // Inizializza Firebase solo se non già inizializzato
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    this.db = firebase.firestore();
    this.storage = firebase.storage();
    this.initialized = true;

    console.log('✓ Firebase Service inizializzato');
  }

  // ========== GESTIONE PROGETTI ==========

  async saveProject(projectData) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const projectDoc = {
        name: projectData.name,
        data: projectData.data,
        customModelsMetadata: projectData.customModelsMetadata || [],
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      };

      const docRef = await this.db.collection('projects').add(projectDoc);
      console.log('✓ Progetto salvato con ID:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('Errore salvataggio progetto:', error);
      throw error;
    }
  }

  async updateProject(projectId, projectData) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const projectDoc = {
        name: projectData.name,
        data: projectData.data,
        customModelsMetadata: projectData.customModelsMetadata || [],
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      };

      await this.db.collection('projects').doc(projectId).update(projectDoc);
      console.log('✓ Progetto aggiornato:', projectId);
      return projectId;
    } catch (error) {
      console.error('Errore aggiornamento progetto:', error);
      throw error;
    }
  }

  async loadProject(projectId) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const doc = await this.db.collection('projects').doc(projectId).get();

      if (!doc.exists) {
        throw new Error('Progetto non trovato');
      }

      const data = doc.data();
      console.log('✓ Progetto caricato:', projectId);

      return {
        id: doc.id,
        name: data.name,
        data: data.data,
        customModelsMetadata: data.customModelsMetadata || [],
        createdAt: data.createdAt,
        updatedAt: data.updatedAt
      };
    } catch (error) {
      console.error('Errore caricamento progetto:', error);
      throw error;
    }
  }

  async getAllProjects() {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const snapshot = await this.db
        .collection('projects')
        .orderBy('updatedAt', 'desc')
        .get();

      const projects = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        projects.push({
          id: doc.id,
          name: data.name,
          createdAt: data.createdAt,
          updatedAt: data.updatedAt
        });
      });

      console.log(`✓ Caricati ${projects.length} progetti`);
      return projects;
    } catch (error) {
      console.error('Errore caricamento lista progetti:', error);
      throw error;
    }
  }

  async deleteProject(projectId) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      await this.db.collection('projects').doc(projectId).delete();
      console.log('✓ Progetto eliminato:', projectId);
    } catch (error) {
      console.error('Errore eliminazione progetto:', error);
      throw error;
    }
  }

  // ========== GESTIONE STORAGE MODELLI CUSTOM ==========

  async uploadCustomModel(file, modelId) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const storageRef = this.storage.ref();
      const modelRef = storageRef.child(`custom-models/${modelId}.glb`);

      // Upload del file
      const snapshot = await modelRef.put(file);
      
      // Ottiene URL di download
      const downloadURL = await snapshot.ref.getDownloadURL();
      
      console.log('✓ Modello custom caricato:', modelId);
      return downloadURL;
    } catch (error) {
      console.error('Errore upload modello custom:', error);
      throw error;
    }
  }

  async downloadCustomModel(modelId) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const storageRef = this.storage.ref();
      const modelRef = storageRef.child(`custom-models/${modelId}.glb`);

      // Scarica come ArrayBuffer
      const downloadURL = await modelRef.getDownloadURL();
      const response = await fetch(downloadURL);
      const arrayBuffer = await response.arrayBuffer();

      console.log('✓ Modello custom scaricato:', modelId);
      return arrayBuffer;
    } catch (error) {
      console.error('Errore download modello custom:', error);
      throw error;
    }
  }

  async customModelExists(modelId) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const storageRef = this.storage.ref();
      const modelRef = storageRef.child(`custom-models/${modelId}.glb`);

      // Tenta di ottenere i metadati
      await modelRef.getMetadata();
      return true;
    } catch (error) {
      if (error.code === 'storage/object-not-found') {
        return false;
      }
      throw error;
    }
  }

  async deleteCustomModel(modelId) {
    if (!this.initialized) {
      throw new Error('Firebase non inizializzato');
    }

    try {
      const storageRef = this.storage.ref();
      const modelRef = storageRef.child(`custom-models/${modelId}.glb`);

      await modelRef.delete();
      console.log('✓ Modello custom eliminato:', modelId);
    } catch (error) {
      console.error('Errore eliminazione modello custom:', error);
      throw error;
    }
  }
}

export default FirebaseService;